import React, { Component } from 'react';
import { getDisplayTime, getUTCDateTime } from '../../utils';
import './styles.css';

class FlightListTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.select = this.select.bind(this);
        this.update = this.update.bind(this);
        this.showEff = this.showEff.bind(this);
    }

    update(e, flight, index, server) {
        e.preventDefault();
        flight[e.currentTarget.name] = e.currentTarget.value;
        this.props.onUpdateFlight && this.props.onUpdateFlight(flight, index, server);
    }

    select(e, flight) {
        e.preventDefault();
        return this.props.onSelectFlight && this.props.onSelectFlight(flight);
    }

    showEff(e, flight) {
        e.preventDefault();
        return this.props.onShowEff && this.props.onShowEff(flight);
    }

    render() {
        let crewRotations = {};
        let len = this.props.flights.length;
        let markTime = Date.now() + (80 * 60 * 1000);
        let markDone = false;
                
        //let showindex = -1 ;
        //let showindexcmp = -1 ;

        let tableRows = this.props.flights.map((flight, index) => {
            let { id, flt, acHist, dDate, dep, arr, reg, mel, cdl, std, sta, etd, eta, atd, ab, cap, capName, capQual, capMob, fo, foName, foQual, foMob, fic, adc, ezfw, azfw, cfp, fob, crewRotn, status, remark1, remark2, isCap, isFo, tank, email, SingleCFP,isSTDComp,flightTyp,IsShowCrewRotation,IsLongGap,IsFoCange,WorkAllocationType,WorkAllocatedTo,DerivedDepartureTiming,DerivedArrivalTiming } = flight;
            let isShowCrewRotation = IsShowCrewRotation ;
            let isLongGap = IsLongGap;
            let isFoChange = IsFoCange;
            let isShowCrewRotationOld = false ;
            let isLongGapOld = false;
            let isFoChangeOld = false;
            let isEtd90MinsMoreStd = false;
            let key = `${dDate}_${cap}`;
            let mark = false;
            //let international =  WorkAllocationType  == 21 ? this.props.flights[index].remark1 : "" ;
            //let completefolder = WorkAllocationType  == 11 ? this.props.flights[index].remark1 : "";

            //let international =  WorkAllocationType  == 21 ? remark1 : "" ;
            //let completefolder = WorkAllocationType  == 11 ? remark1 : "";

            
     
            // console.log(this.props.flights, "check api")

                // console.log(showindex, "showing index value");
            //console.log(crewRotations[key], "Check crewrotation key")
            // if (!crewRotations.hasOwnProperty(key)) {
            //     isShowCrewRotationOld = true;
            // } else {
            //     if (DerivedDepartureTiming - crewRotations[key].DerivedArrivalTiming >= 3 * 60 * 60 * 1000) {
            //         isLongGapOld = true;
            //     }
            //     if (crewRotations[key].fo !== fo) {
            //         isFoChangeOld = true;
            //         isShowCrewRotationOld = true;
            //     }
            // }
            // crewRotations[key] = { DerivedArrivalTiming, fo };
            //console.log(flt, "flight Number", isShowCrewRotationOld, " old crewRotation" , isFoChangeOld, "old foChnge", isFoChangeOld, "old longap",  isShowCrewRotation, "new crew", isFoChange, "fo New", isLongGap, "longgap new");

            if (etd) {
                isEtd90MinsMoreStd = etd - std > 90 * 60 * 1000;
            }

            if (!markDone && index + 1 < len && markTime - this.props.flights[index + 1].std < 0) {
                mark = true;
                markDone = true;
            }

            // if(isShowCrewRotation == false && isSTDComp == true  && international == "" && completefolder == "" ){
            
            //     if(showindex < SingleCFP.length-1){
            //         showindex= showindex+1
            //     }
            //     else{
            //         showindex = 0;
            //     }
            //     } 

            //     if(isShowCrewRotation == false && isSTDComp == true  && international == "" && SingleCFP == "" ){
            
            //         if(showindexcmp < completefolder.length-1){
            //             showindexcmp= showindexcmp+1
            //         }
            //         else{
            //             showindexcmp = 0;
            //         }
            //         }
            const handleSingleCFP = () => {
                    
            }

            // if(isShowCrewRotation == false  && isSTDComp == true && international == "" && completefolder == "")
            // {
            //     console.log(this.props.flights[index].remark1, "check remark1" );
            //     this.props.flights[index].remark1  =  (this.props.flights[index].remark1 ==null||this.props.flights[index].remark1 =="")  ?SingleCFP[showindex]:this.props.flights[index].remark1;
               
            // }
          

            // else{
            //     flight[index].remark1=flight[index].remark1;
            // }
            // if(!WorkAllocatedTo == "" || !WorkAllocatedTo == null){
            //  console.log('test')}else{}
            // console.log(isShowCrewRotation, flt , international, completefolder, 'Check remak1 value');
            //console.log(getUTCDateTime(std, 'D-M-Y') || getDisplayTime(std) > SingleCFPLST.Timefrom ? 'Hello' : 'Hi' ,'checking date formate')
            return (
                <>
            <tr key={id} style={{ borderBottom: mark ? 'solid .5rem #ed1c24' : '' }}>
                <td className={`align-middle text-left text-nowrap cursor-pointer ${['T', 'D', 'R', 'A'].includes(flt.charAt(flt.length - 1)) ? 'bg-green' : ''}`}
                    data-toggle='tooltip'
                    onClick={e => this.select(e, flight)}>
                    <span className={`${acHist.length ? 'border-bottom-turquoise' : ''}`}>{flt}</span>
                    <span className='tooltip-content border text-center'>
                        <span className='px-1'>{dDate} {getDisplayTime(std)}</span>
                        {
                            acHist.length ?
                                <table className='table table-sm table-bordered text-light m-0'>
                                    <thead>
                                        <tr>
                                            <th scope='col'>Tail</th>
                                            <th scope='col'>Modified</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            acHist.map(({ id, reg, modified }) => <tr key={id}>
                                                <td>{reg}</td>
                                                <td>{modified}</td>
                                            </tr>)
                                        }
                                    </tbody>
                                </table> : null
                        }
                    </span>
                </td>
                <td className={`align-middle ${tank ? 'bg-yellow text-dark' : ''}`}>{dep}</td>
                <td className='align-middle'>{arr}</td>
                <td className={`align-middle text-nowrap ${mel.length || cdl.length ? 'bg-purple' : ''}`}
                    data-toggle='tooltip'>
                    {reg}
                    <span className='tooltip-content'>
                        {
                            mel.length ? <div className='border'>
                                MEL
                                    <ul className='list-group text-left'>
                                    {
                                        mel.map((m, i) => <li key={i}
                                            className='list-group-item p-0 bg-transparent rounded-0 px-1'>
                                            {m}
                                        </li>)
                                    }
                                </ul>
                            </div> : null
                        }
                        {
                            cdl.length ? <div className='border border-top-0'>
                                CDL
                                    <ul className='list-group text-left'>
                                    {
                                        cdl.map((c, i) => <li key={i}
                                            className='list-group-item p-0 bg-transparent rounded-0 px-1'>
                                            {c}
                                        </li>)
                                    }
                                </ul>
                            </div> : null
                        }
                    </span>
                </td>
                <td className='align-middle whitespace-pre'>{getDisplayTime(std)}</td>
                <td className='align-middle whitespace-pre'>{getDisplayTime(sta)}</td>
                <td className={`align-middle whitespace-pre ${isEtd90MinsMoreStd ? 'text-orange' : ''}`}>{getDisplayTime(etd)}</td>
                <td className='align-middle whitespace-pre'>{getDisplayTime(eta)}</td>
                <td className='align-middle whitespace-pre'>{getDisplayTime(atd)}</td>
                <td className='align-middle whitespace-pre'>{getDisplayTime(ab)}</td>
                <td className={`align-middle ${isCap ? 'text-gold' : ''}`}
                    data-toggle='tooltip'>
                    {capName}
                    <span className='tooltip-content border text-left text-nowrap px-1'>
                        {capQual}<br />{capMob}
                    </span>
                </td>
                <td className={`align-middle ${isFo ? ' text-gold' : ''}`}
                    data-toggle='tooltip'>
                    {foName}
                    <span className='tooltip-content border text-left text-nowrap px-1'>
                        {foQual}<br />{foMob}
                    </span>
                </td>
                <td className='align-middle'>
                    <input className='form-control form-control-sm rounded-0 bg-transparent text-light text-truncate text-center p-0'
                        name='fic'
                        value={fic}
                        onChange={e => this.update(e, flight, index, false)}
                        onBlur={e => this.update(e, flight, index, true)}
                        style={{ maxWidth: '3rem' }}
                        autoComplete='off' /></td>
                <td className='align-middle'>
                    <input className='form-control form-control-sm rounded-0 bg-transparent text-light text-truncate text-center p-0'
                        name='adc'
                        value={adc}
                        onChange={e => this.update(e, flight, index, false)}
                        onBlur={e => this.update(e, flight, index, true)}
                        style={{ maxWidth: '3rem' }}
                        autoComplete='off' /></td>
                <td className={`align-middle ${cfp && ezfw - cfp > 500 ? 'bg-red' : ''}`}>{ezfw}</td>
                <td className='align-middle'>{azfw}</td>
                <td className='align-middle'>{cfp}</td>
                <td className='align-middle'>{fob}</td>
                <td className='align-middle whitespace-pre'>
                    {isLongGap ? 'LONG GAP\n' : null}
                    {isFoChange ? 'FO CHANGE\n' : null}
                    {isShowCrewRotation ? crewRotn : null}
                </td>
                <td className='align-middle'>
                    {
                        status ? <a href='#vieweff' onClick={e => this.showEff(e, flight)}>View EFF</a> : null
                    }                  
                    <br />
                    {
                        email ? <label>Email Sent</label> : null
                    }
                </td>
                <td className='align-middle'>
                {WorkAllocatedTo == "" || WorkAllocatedTo == null ? "" : (<><label>{WorkAllocatedTo}</label><br></br></> ) }
                    <input className='form-control form-control-sm rounded-0 bg-transparent text-light text-truncate text-center p-0'
                        name='remark1'
                        // value={isShowCrewRotation == false && remark1 == ''  || remark1 == null ?  SingleCFP[showindex] : remark1}
                        // value={isShowCrewRotation == false  && international == "" && completefolder == "" ? SingleCFP[showindex] : international == "" ? completefolder : international}
                       
                        //value={ this.props.flights[index].remark1}
                        value={ remark1 == "" || remark1 == null ? "" : remark1 }
                        onChange={e => this.update(e, flight, index, false)}
                        onBlur={e => this.update(e, flight, index, true)}
                        style={{ maxWidth: '8rem' }}
                        autoComplete='off' /></td>
                <td className='align-middle'>
                    <input className='form-control form-control-sm rounded-0 bg-transparent text-light text-truncate text-center p-0'
                        name='remark2'
                        value={remark2}
                        onChange={e => this.update(e, flight, index, false)}
                        onBlur={e => this.update(e, flight, index, true)}
                        style={{ maxWidth: '8rem' }}
                        autoComplete='off' /></td>
            </tr>
            </>
            );
        });

        return (
            <>
            <table id='FlightListTable'
                className='table table-sm table-bordered table-hover text-light text-center m-0'
                style={{ fontSize: '10px' }}>
                <thead>
                    <tr className='text-nowrap'>
                        <th scope='col'>F/No</th>
                        <th scope='col'>From</th>
                        <th scope='col'>To</th>
                        <th scope='col'>Tail</th>
                        <th scope='col'>STD</th>
                        <th scope='col'>STA</th>
                        <th scope='col'>ETD</th>
                        <th scope='col'>ETA</th>
                        <th scope='col'>C/OF</th>
                        <th scope='col'>A/B</th>
                        <th scope='col'>Captain</th>
                        <th scope='col'>First Officer</th>
                        <th scope='col'>FIC</th>
                        <th scope='col'>ADC</th>
                        <th scope='col'>EZFW</th>
                        <th scope='col'>AZFW</th>
                        <th scope='col'>CFP</th>
                        <th scope='col'>FOB</th>
                        <th scope='col'>Crew Rotation</th>
                        <th scope='col'>Status</th>
                        <th scope='col'>Remark 1</th>
                        <th scope='col'>Remark 2</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        tableRows.length ? tableRows :
                            <tr>
                                <td className='text-center font-weight-light font-italic h6'
                                    colSpan='100%'
                                    style={{ borderColor: '#213852' }}>No flights found.</td>
                            </tr>
                    }
                </tbody>
                <tfoot></tfoot>
            </table>
            </>
        );
    }
}

export default FlightListTable;